import classNames from 'classnames'
import React from 'react'
import { Cross } from '@yy/one-icon'
import { useTranslation } from '../../../hooks'
import Tooltip from '../components/Tooltip'
import styles from './index.module.less'

const CloseBtn: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={`${t('feedback.close')} ESC`}>
      <div className={classNames(styles.closeBtn, styles.btn)} {...props}>
        <Cross origin />
      </div>
    </Tooltip>
  )
}

export default CloseBtn
